export const GET_CHAT_CONSTANTS = "GET_CHAT_CONSTANTS"
export const SAVE_CHAT_CONSTANTS = "SAVE_CHAT_CONSTANTS"
